import * as React from 'react';
import {
  StackLayout,
  Box,
  TextAction,
  UtilityText,
  Button,
} from '@leagueplatform/genesis-core';
import { EntityStatus } from '@web-config-app/core';
import { useIntl } from '@leagueplatform/locales';
import { CopyButton } from '@web-config-app/core-react-ui';
import { EntityStatusBadge } from './entity-status-badge.component';

export interface EntitySelectValueProps {
  openChooseFromList: () => void;
  onClear?: (args: any) => void;
  isArrayItem?: boolean;
  disabled?: boolean;
  leadingThumbnail?: React.ReactNode;
  title: string;
  href: string;
  secondaryText?: string;
  status?: EntityStatus;
  copyItemLabel?: string;
}

export const EntitySelectValue: React.FC<EntitySelectValueProps> = ({
  openChooseFromList,
  onClear,
  isArrayItem = false,
  disabled,
  leadingThumbnail,
  title,
  href,
  secondaryText,
  copyItemLabel,
  status,
}) => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      orientation="horizontal"
      horizontalAlignment="start"
      verticalAlignment="center"
      spacing="$one"
      css={{ paddingY: '$half', width: '100%' }}
    >
      {leadingThumbnail}
      <Box css={{ flexGrow: 1 }}>
        <TextAction indicator="newTabInternal" target="_blank" href={href}>
          {title}
        </TextAction>
      </Box>
      {secondaryText ? (
        <>
          <UtilityText
            emphasis="subtle"
            css={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'block',
              flexShrink: 1,
              maxWidth: '15rem',
            }}
          >
            {secondaryText}
          </UtilityText>
          <CopyButton
            label={formatMessage({ id: 'COPY' }, { title: copyItemLabel })}
            priority="tertiary"
            contents={secondaryText}
            hideLabel
          />
        </>
      ) : null}
      {status ? <EntityStatusBadge status={status} /> : null}
      <Button
        size="medium"
        priority="secondary"
        quiet
        onClick={() => openChooseFromList()}
        icon="interfaceChange"
        hideLabel
        disabled={disabled}
      >
        {formatMessage({ id: 'CHANGE_SELECTION' })}
      </Button>
      {isArrayItem === false ? (
        <Button
          type="button"
          icon="tinyClear"
          hideLabel
          quiet
          priority="tertiary"
          size="toolbar"
          disabled={disabled}
          onClick={onClear}
        >
          {formatMessage({ id: 'CLEAR_ENTITY_REFERENCE_SELECTION' })}
        </Button>
      ) : null}
    </StackLayout>
  );
};
